import { Card, CardContent, CardHeading } from '@/components/ui'
import { useToast } from '@/hooks'
import {
  type ProjectTask,
  useFetchProjectTasks,
  useProjectTasks,
  useToggleProjectTask,
} from '@/modules/projects'
import { TaskRow } from './TaskRow'

interface OverviewTasksCardProps {
  slug: string
}

export const OverviewTasksCard = ({ slug }: OverviewTasksCardProps) => {
  useFetchProjectTasks(slug)
  const tasks = useProjectTasks()
  const toggle = useToggleProjectTask()
  const { errorToast } = useToast()

  if (tasks.length === 0) return null

  const handleToggle = (task: ProjectTask) =>
    toggle(slug, task).catch((error) =>
      errorToast('Failed to update the task', error),
    )

  return (
    <Card>
      <CardHeading title="Follow-up tasks" />
      <CardContent className="space-y-1">
        {tasks.map((task) => (
          <TaskRow key={task.id} task={task} onToggle={handleToggle} />
        ))}
      </CardContent>
    </Card>
  )
}
